import { getCityByPrefix } from 'Api/locationApi'
import { getFavoriteRegionList, addFavoriteRegion, deleteFavoriteRegion } from 'Services/regionManager'
import { getMainRegion, setMainRegion } from 'Services/regionManager'
import { parseCity } from 'Parsers/regionParser'

export const state = {
  requesting: {
    regionList: [],
    favoriteRegionList: [],
  },

  regionList: [],
  selectedRegion: null,
}

export const getters = {
  mainRegion: state => state.selectedRegion || getMainRegion(),
  favoriteRegionList: state => getFavoriteRegionList() || []
}

export const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_region_list(state, regionList) {
    state.regionList = regionList
  },

  set_region(state, selectedRegion) {
    state.selectedRegion = selectedRegion
  }
}

export const actions = {
  async getRegionList({ commit }, prefix) {
    commit('request_start', 'regionList')

    try {
      const { data } = await getCityByPrefix(prefix)
      const regionList = data.map(parseCity)

      commit('set_region_list', regionList)
      commit('request_success', 'regionList')

      return regionList
    } catch (err) {
      commit('request_failure', 'regionList')

      throw err
    }
  },

  updateFavoriteRegionList({ getters }, region) {
    const { favoriteRegionList } = getters

    if (favoriteRegionList.length >= 5) {
      favoriteRegionList.slice(4).forEach(item => deleteFavoriteRegion(item.id))
    }

    addFavoriteRegion(region)
  },

  async selectRegion({ commit, dispatch }, region) {
    setMainRegion(region)
    dispatch('updateFavoriteRegionList', region)

    commit('set_region', region)
  }
}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}